<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Scan Complete'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image
            [src]="'assets/img/checkmark-circle-green.svg'"
            class="title-size" />
          <tidy-text
            [header]="'Scan Completed Successfully'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Your property map has been created and saved. The scan data can be used to help pros understand your space better.'" />
        </tidy-row>
      </tidy-card>

      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="'Scan Details'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="('Rooms captured: ' | translate) + scanResult?.roomCount" />
        </tidy-row>
        @if (scanResult?.usdzPath) {
          <tidy-row>
            <tidy-text
              [helper]="'3D model saved'" />
          </tidy-row>
        }
        @if (scanResult?.jsonPath) {
          <tidy-row>
            <tidy-text
              [helper]="'Floor plan data saved'" />
          </tidy-row>
        }
      </tidy-card>

      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="'What\'s Next?'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'You can view your scan now. When you are ready, upload it to the cloud to add it to your property details permanently.'" />
        </tidy-row>
      </tidy-card>

      <tidy-button
        [text]="'View 3D Scan'"
        [action]="boundViewScan"
        class="secondary"
        style="margin-bottom: 12px;" />

      <tidy-button
        [text]="isUploading ? 'Uploading...' : (uploadSuccess ? ('Uploaded to Cloud' | translate) : ('Save to Cloud' | translate))"
        [action]="boundUploadToCloud"
        [disabled]="isUploading || uploadSuccess"
        class="primary"
        style="margin-bottom: 12px;" />

      <tidy-button
        [text]="'Back to Property'"
        [action]="boundGoToProperty"
        class="tertiary" />

      <tidy-row [align]="'center'" class="extra-top-padding">
        <tidy-text
          [actionBody]="'Scan Again'"
          (action)="scanAgain()"
          class="link" />
      </tidy-row>
    }

    @if (!loaded) {
      <tidy-card>
        <tidy-row>
          <ion-skeleton-text animated style="width: 60%" />
        </tidy-row>
      </tidy-card>
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
